import { Box, Grid, Heading } from "@chakra-ui/react";

import { Event as ThreediEvent } from "@nens/threedi/openapi-client";

import { GridCard } from "../../components/GridCard";

import EventDetailsVisualisation from "./EventDetailsVisualisation";

type InitialConditionsProps = {
  events: ThreediEvent;
};

function InitialConditions({ events }: InitialConditionsProps) {
  return (
    <Box marginTop="18px">
      <Heading size="lg" marginBottom="8" marginTop="8">
        Initial Conditions
      </Heading>
      <Grid gap="1rem" templateColumns="repeat(4, 1fr)">
        {events?.initialTwodwaterlevel ? (
          <GridCard title="2D water level">
            <p>Value: {events?.initialTwodwaterlevel?.value}</p>
          </GridCard>
        ) : null}
        {events?.initialTwodwaterraster ? (
          <GridCard title="2D water level">
            <p>Raster. Aggregation method: {events.initialTwodwaterraster?.aggregationMethod}.</p>
          </GridCard>
        ) : null}
        {events?.initialOnedwaterlevel ? (
          <GridCard title="1D water level">
            <p>Value: {events?.initialOnedwaterlevel?.value}</p>
          </GridCard>
        ) : null}
        {events?.initialOnedwaterlevelpredefined ? (
          <GridCard title="1D water level">
            <p>From Spatialite.</p>
          </GridCard>
        ) : null}
        {events?.initialGroundwaterlevel ? (
          <GridCard title="Ground water level">
            <p>Value: {events?.initialGroundwaterlevel?.value}</p>
          </GridCard>
        ) : null}
        {events?.initialGroundwaterraster ? (
          <GridCard title="Ground water level">
            <p>
              Raster. Aggregation method: {events?.initialGroundwaterraster?.aggregationMethod}.
            </p>
          </GridCard>
        ) : null}
        {events?.initialSavedstate ? (
          <GridCard title="Saved state">
            <p>
              Used saved state "{events!.initialSavedstate!.savedState!.name}
              ".
            </p>
          </GridCard>
        ) : null}
        {events?.initialWinddragcoefficient ? (
          <GridCard title="Wind drag coefficient">
            <p>Value: {events?.initialWinddragcoefficient?.value}.</p>
          </GridCard>
        ) : null}
      </Grid>
      <EventDetailsVisualisation type="initial" events={events} />
    </Box>
  );
}

export default InitialConditions;
